<app-header-auth></app-header-auth>

<div class="m-auto container text-center">
  <div class="card login-form border-0 bg-none m-auto">
    <div class="card-header border-0 bg-none mt-3">
      <h4 class="text-center"> {{ 'RESETPASS' | translate }}</h4>
    </div>

    <div class="card-body p-0">
      <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">

        <!-- ახალი პაროლი -->
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            formControlName="password"
            id="password"
            placeholder="{{ 'NEW_PASSWORD' | translate }}"
            autocomplete="new-password"
            [ngClass]="{'is-invalid': resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched}"
            required>
          <label for="password">{{ 'NEW_PASSWORD' | translate }}</label>

          <!-- Password Strength Progress Bar -->
          <div class="password-strength mt-2" *ngIf="isTyping">
            <div class="progress">
              <div class="progress-bar"
                   [ngClass]="{'bg-danger': passwordStrength <= 40, 'bg-warning': passwordStrength > 40 && passwordStrength < 80, 'bg-success': passwordStrength >= 80}"
                   [style.width.%]="passwordStrength"></div>
            </div>
            <small *ngIf="passwordStrength <= 40" class="text-danger">{{ 'VALIDATION.PASSWORD_STRENGTH_WEAK' | translate }}</small>
            <small *ngIf="passwordStrength > 40 && passwordStrength < 80" class="text-warning">{{ 'VALIDATION.PASSWORD_STRENGTH_MEDIUM' | translate }}</small>
            <small *ngIf="passwordStrength >= 80" class="text-success">{{ 'VALIDATION.PASSWORD_STRENGTH_STRONG' | translate }}</small>
          </div>

          <!-- Error Messages -->
          <div class="invalid-feedback" *ngIf="resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched">
            <div *ngIf="resetPasswordForm.get('password')?.errors?.['required']">
              {{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}
            </div>
            <div *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']">
              {{ 'VALIDATION.PASSWORD_MIN' | translate }}
            </div>
            <div *ngIf="resetPasswordForm.get('password')?.errors?.['pattern'] && !hasLowerCase()">
              {{ 'VALIDATION.PASSWORD_LOWERCASE' | translate }}
            </div>
        
            <div *ngIf="resetPasswordForm.get('password')?.errors?.['pattern'] && !hasNumber()">
              {{ 'VALIDATION.PASSWORD_NUMBER' | translate }}
            </div>
          </div>
        </div>

        <!-- გაიმეორეთ ახალი პაროლი -->
        <div class="form-floating mb-3">
          <input
            type="password"
            id="password_confirmation"
            formControlName="password_confirmation"
            class="form-control"
            [ngClass]="{'is-invalid': resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('password_confirmation')?.touched}"
            placeholder="{{ 'CONFIRM_NEW_PASSWORD' | translate }}"
            autocomplete="new-password">
          <label for="password_confirmation">{{ 'CONFIRM_NEW_PASSWORD' | translate }}</label>
        
          <div class="invalid-feedback" 
              *ngIf="resetPasswordForm.get('password_confirmation')?.errors?.['passwordMismatch'] 
                      && resetPasswordForm.get('password_confirmation')?.touched">
            {{ 'VALIDATION.PASSWORD_MISMATCH' | translate }}
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-floating mb-3">
          <button
            class="btn btn-lg w-100 btn-primary rounded-3"
            [disabled]="!resetPasswordForm.valid || resetPasswordForm.hasError('passwordMismatch') || loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" ></span>
            {{ 'CHANGE_PASSWORD' | translate }}
          </button>
        </div>
      </form>

      <!-- Login Link -->
      <div class="d-flex align-items-center justify-content-center mt-2">
        <a routerLink="/signin">{{ 'SIGNIN' | translate }}</a>
      </div>
    </div>
  </div>
</div>